import { render, staticRenderFns } from "./ViewHospitals.vue?vue&type=template&id=63260460"
import script from "./ViewHospitals.vue?vue&type=script&lang=js"
export * from "./ViewHospitals.vue?vue&type=script&lang=js"
import style0 from "./ViewHospitals.vue?vue&type=style&index=0&id=63260460&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports